module.exports = __webpack_public_path__ + "img/inventory.029f183a.svg";